import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
  }
  return t;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
import { http, STATUS_MAPPING_BATCH_INVOICE } from '../common';
import { timestampToTime, STATUS_MAPPING, formatTime } from '../common';
var TYPE_MAPPING = {
  1: '纸票',
  2: '纸票',
  3: '电子发票'
};
/**
 * 获取用户发票列表
 * [接口文档](https://km.sankuai.com/page/192214196#id-4.3.2%E5%88%86%E9%A1%B5%E8%8E%B7%E5%8F%96%E7%94%A8%E6%88%B7%E5%BC%80%E7%A5%A8%E5%88%97%E8%A1%A8queryUserInvoiceListPage%EF%BC%88/api/invoice/collection/queryUserInvoiceListPage%EF%BC%89post)
 */
export function getInvoiceList(data, config) {
  return __awaiter(this, void 0, void 0, function () {
    var res, list;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, http(__assign({
            url: 'collection/queryUserInvoiceListPage',
            data: data,
            auth: true
          }, config))];
        case 1:
          res = _a.sent();
          if (res && res.code === 200 && res.data) {
            list = res.data.invoiceRecordVOList || [];
            list.forEach(function (item) {
              item.formatTime = timestampToTime(item.invoiceTime);
              item.totalFeeFormat = item.totalFee.toFixed(2);
            });
            res.data.invoiceRecordVOList = list;
          }
          return [2 /*return*/, res];
      }
    });
  });
}
/**
 * 根据`bizType`获取发票列表
 * [接口文档](https://km.sankuai.com/page/192214196#id-4.3.1%E5%88%86%E9%A1%B5%E8%8E%B7%E5%8F%96%E7%94%A8%E6%88%B7%E4%B8%9A%E5%8A%A1%E7%BA%BF%E5%BC%80%E7%A5%A8%E5%88%97%E8%A1%A8queryUserInvoiceListPageByBizType%EF%BC%88/api/invoice/collection/queryUserInvoiceListPageByBizType%EF%BC%89post)
 */
export function getInvoiceListByBizType(data, config) {
  return __awaiter(this, void 0, void 0, function () {
    var res, list;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, http(__assign({
            url: 'collection/queryUserInvoiceListPageByBizType',
            data: data,
            auth: true
          }, config))];
        case 1:
          res = _a.sent();
          if (res && res.code === 200 && res.data) {
            list = res.data.invoiceRecordVOList || [];
            list.forEach(function (item) {
              item.createTimeFormat = formatTime(item.createTime, 'YYYY-MM-DD HH:mm');
              item.formatTime = timestampToTime(item.invoiceTime);
              item.statusDesc = STATUS_MAPPING[item.status];
              item.invoiceTypeDesc = TYPE_MAPPING[item.invoiceType || 3];
              item.totalFeeFormat = item.totalFee.toFixed(2);
            });
            res.data.invoiceRecordVOList = list;
          }
          return [2 /*return*/, res];
      }
    });
  });
}
var formatInvoiceDetail = function formatInvoiceDetail(item) {
  if (item.invoiceTime) {
    item.formatTime = timestampToTime(item.invoiceTime);
  }
  item.totalFeeFormat = item.totalFee.toFixed(2);
};
/**
 * [接口文档](https://km.sankuai.com/page/192214196#id-4.3.3%E8%8E%B7%E5%8F%96%E7%94%A8%E6%88%B7%E5%BD%92%E9%9B%86%E5%8F%91%E7%A5%A8%E8%AF%A6%E6%83%85queryInvoiceDetail%EF%BC%88/api/invoice/collection/queryInvoiceDetail%EF%BC%89post)
 */
export function getInvoiceDetail(data, config) {
  return __awaiter(this, void 0, void 0, function () {
    var res;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, http(__assign({
            url: 'collection/queryInvoiceDetail',
            data: data,
            auth: true
          }, config))];
        case 1:
          res = _a.sent();
          if (res && res.code === 200 && res.data) {
            formatInvoiceDetail(res.data);
            if (res.data.recordSplits) {
              res.data.recordSplits.forEach(function (item) {
                formatInvoiceDetail(item);
              });
            }
          }
          return [2 /*return*/, res];
      }
    });
  });
}
/**
 * 获取发票详情（Batch）
 * https://km.sankuai.com/page/1202761195#id-%E6%9F%A5%E8%AF%A2%E5%8F%91%E7%A5%A8%E8%AF%A6%E6%83%85
 */
export function queryBatchInvoiceHistoryDetail(data, config) {
  return __awaiter(this, void 0, void 0, function () {
    var res;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, http(__assign({
            url: 'collection/queryBatchInvoiceHistoryDetail',
            data: data,
            auth: true
          }, config))];
        case 1:
          res = _a.sent();
          if (res && res.code === 200 && res.data) {
            res.data.forEach(function (item) {
              if (item.invoiceTime) {
                item.formatTime = timestampToTime(item.invoiceTime);
              }
              item.totalFeeFormat = item.totalFee.toFixed(2);
            });
          }
          return [2 /*return*/, res];
      }
    });
  });
}
/**
 * 获取发票列表(Batch)
 * https://km.sankuai.com/page/1202761195#id-%E5%8F%91%E7%A5%A8%E5%8E%86%E5%8F%B2%E6%8E%A5%E5%8F%A3
 */
export function queryBatchInvoiceHistoryList(data, config) {
  return __awaiter(this, void 0, void 0, function () {
    var res, list;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, http(__assign({
            url: 'collection/queryBatchInvoiceHistoryList',
            data: data,
            auth: true
          }, config))];
        case 1:
          res = _a.sent();
          if (res && res.code === 200 && res.data) {
            list = res.data.invoiceRecordVOList || [];
            list.forEach(function (item) {
              item.createTimeFormat = formatTime(item.createTime, 'YYYY-MM-DD HH:mm');
              item.formatTime = timestampToTime(item.invoiceTime);
              item.statusDesc = STATUS_MAPPING_BATCH_INVOICE[item.status];
              item.invoiceTypeDesc = TYPE_MAPPING[item.invoiceType || 3];
              item.totalFeeFormat = item.totalFee.toFixed(2);
            });
            res.data.invoiceRecordVOList = list;
          }
          return [2 /*return*/, res];
      }
    });
  });
}
// 获取添加微信卡包的url
export function queryWxInvoiceUrlByReceipt(data, config) {
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      return [2 /*return*/, http(__assign({
        url: 'collection/queryWxInvoiceUrlByReceipt',
        data: data,
        auth: true
      }, config))];
    });
  });
}
/**
 * 通过归集发票ID发送邮件,有app内打开和浏览器内打开发送几个场景
 * [接口文档](https://km.sankuai.com/page/192214196#id-4.3.4%E5%8F%91%E9%80%81%E9%82%AE%E4%BB%B6sendEmailByCollectionId%EF%BC%88/api/invoice/collection/sendEmailByCollectionId%EF%BC%89post)
 */
export function sendEmailByCollectionId(data, config) {
  return http(__assign({
    url: 'collection/sendEmailByCollectionId',
    data: data,
    auth: true
  }, config));
}
/**
 * 小票码开票成功后再次扫码，进的详情页，发邮件用的这个方法。调用频率很低，一个月几十个
 * [接口文档](https://km.sankuai.com/page/192214196#id-4.3.5%E6%89%AB%E7%A0%81%E8%AF%A6%E6%83%85%E9%A1%B5%E5%8F%91%E9%80%81%E9%82%AE%E4%BB%B6sendEmailByInvoiceId%EF%BC%88/api/invoice/collection/sendEmailByInvoiceId%EF%BC%89post)
 */
export function sendEmailByInvoiceId(data, config) {
  return http(__assign({
    url: 'collection/sendEmailByInvoiceId',
    data: data,
    auth: true
  }, config));
}
/**
 * [接口文档](https://km.sankuai.com/page/192214196#id-4.3.6%E5%88%A0%E9%99%A4%E7%94%A8%E6%88%B7%E5%BD%92%E9%9B%86%E5%8F%91%E7%A5%A8deleteUserInvoiceRecord%EF%BC%88/api/invoice/collection/deleteUserInvoiceRecord%EF%BC%89post)
 */
export function deleteInvoiceById(id, config) {
  return http(__assign({
    url: 'collection/deleteUserInvoiceRecord',
    data: {
      collectionInvoiceId: id
    },
    auth: true
  }, config));
}
/**
 * 批次号发票申请获取销方信息
 * https://km.sankuai.com/page/1222590297 get
 */
export function queryBatchInfoList(data, config) {
  return http(__assign({
    url: 'collection/queryBatchInfoList',
    data: data,
    auth: true
  }, config));
}
export function sendEmailByBatchId(data, config) {
  return http(__assign({
    url: 'collection/sendEmailByBatchId',
    data: data,
    auth: true
  }, config));
}